/** Lobby mount point for the same-domain game launcher (`/game-play`). */
export const GAME_PLAY_PATH_PREFIX = '/game-play';

export const createPathFilter =
    (prefix: string) =>
    (pathname: string): boolean =>
        pathname === prefix || pathname.startsWith(`${prefix}/`);

/** True when a pathname is the lobby launcher mount (`/game-play` or `/game-play/...`). */
export const isGamePlayPath = createPathFilter(GAME_PLAY_PATH_PREFIX);
